export default new class sidebar {
  constructor() {
    this.linkSelector = 'sidebar-navigation-menu__submenu';
    this.activeLinkSelector = 'active';
    this.contentSelector = 'sidebar-navigation-menu__item-submenu';
    this.invisibleContentSelector = 'hidden';
    this.init();
  }

  init() {
    $(document)
      .on('click', `.${this.linkSelector}`, (e) => {
        e.preventDefault();

        const { target } = e;

        if ($(target).hasClass(this.activeLinkSelector)) {
          this.hideTab(target);
        } else {
          this.showTab(target);
        }
      });
  }

  showTab(target) {
    $(target)
      .addClass(this.activeLinkSelector);

    const id = $(target)
      .attr('href');
    const tabContent = $(id);
    tabContent.removeClass(this.invisibleContentSelector);
    tabContent.addClass(this.activeLinkSelector);
  }

  hideTab(target) {
    $(target)
      .removeClass(this.activeLinkSelector);

    const id = $(target)
      .attr('href');
    const tabContent = $(id);
    tabContent.addClass(this.invisibleContentSelector);
    tabContent.removeClass(this.activeLinkSelector);
  }
}();
